export const multiFactorAuthTypes = {
  SMS: 'SMS',
  TOTP: 'TOTP'
};